export default {
  morning: '05:00 - 10:59',
  noon: '11:00 - 16:59',
  evening: '17:00 - 22:59',
  midnight: '23:00 - 04:59',
}
